import Image from 'next/image';
import React from 'react';
import { slackLogger } from '@shared/utils/off-chain/slack-logger';
import { Button } from '../ui/button';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    if (process.env.NEXT_PUBLIC_LIT_NETWORK != 'datil-dev') {
      slackLogger({
        type: 'APPLICATION_ERROR',
        payload: {
          error: error.message,
          stack: error.stack
        }
      });
    }
  }
  render() {
    if (this.state.hasError) {
      return <div data-sentry-component="ErrorBoundary" data-sentry-source-file="ErrorBoundary.tsx">
          <div className='h-[100vh] py-6 z-80 relative overflow-auto rounded-b-3xl purple-gradient-error'>
            <div className='ta-c h-[600px] flex items-center w-[100%]'>
              <div className='w-full'>
                <Image height={100} width={100} src={'/static/images/error.png'} alt={'error'} className={`w-[83px] h-[83px] mt-10 transition-opacity duration-500`} data-sentry-element="Image" data-sentry-source-file="ErrorBoundary.tsx" />

                <div className='mw-[288px] px-4'>
                  <p className={`mt-[100px] text-genius-gradient text-[24px] font-semibold leading-8`}>
                    Looks like we had an error!
                  </p>

                  <p className='text-[12px] text-genius-gradient mt-10 w-[240px]'>
                    Not very smart, we know. The Genius Team has been notified and will fix this as
                    soon as possible!
                  </p>
                </div>

                <div className='w-full absolute bottom-6'>
                  <Button onClick={() => {
                  window.location.href = '/home';
                }} className='bg-genius-blue h-[56px] md:hover:bg-genius-blue text-genius-cream rounded-full w-[95%] text-[14px] mb/1' data-sentry-element="Button" data-sentry-source-file="ErrorBoundary.tsx">
                    Refresh
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;